import { Link } from 'react-router-dom';

interface ProductCardProps {
  id: string;
  name: string;
  price: number;
  originalPrice: number;
  image: string;
  badge?: string;
  category: string;
  rating: number;
  reviews: number;
}

export default function ProductCard({
  id,
  name,
  price,
  originalPrice,
  image,
  badge,
  category,
  rating,
  reviews,
}: ProductCardProps) {
  const discount = Math.round((1 - price / originalPrice) * 100);

  return (
    <Link
      to={`/category/${category}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
      data-product-shop=""
    >
      <div className="relative w-full aspect-square overflow-hidden">
        <img
          src={image}
          alt={name}
          title={`${name} - 愽彩糖果`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {badge && (
          <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-950">
            {badge}
          </span>
        )}
        {discount > 0 && (
          <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full text-xs font-medium bg-secondary-500 text-white">
            -{discount}%
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
          {name}
        </h3>
        <div className="flex items-center gap-1 mb-2">
          <div className="flex items-center text-accent-500">
            {Array.from({ length: 5 }).map((_, i) => (
              <i
                key={i}
                className={`text-xs ${i < Math.floor(rating) ? 'ri-star-fill' : i < rating ? 'ri-star-half-fill' : 'ri-star-line text-foreground-300'}`}
              ></i>
            ))}
          </div>
          <span className="text-xs text-foreground-400">({reviews})</span>
        </div>
        <div className="flex items-baseline gap-2">
          <span className="text-lg font-bold text-primary-500">&yen;{price.toFixed(2)}</span>
          {originalPrice > price && (
            <span className="text-xs text-foreground-400 line-through">&yen;{originalPrice.toFixed(2)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}